import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { IntegrityMonitorPauseSchema } from '../type';
import { GzButtonWebComponent } from '../../../ui/gzButton';
import { GzTitleWebComponent } from '../../../ui/gzTitle';
import { GzLabeledContentWebComponent } from '../../../ui/gzLabeledContent';
import { GzTimePickerWebComponent } from '../../../ui/gzTimePicker';

export class IntegrityMonitorPauseView extends BaseWebComponentView {
  public dom: {
    $targetsLabel: GzLabeledContentWebComponent;
    $targetsValue: HTMLElement;

    $durationLabel: GzLabeledContentWebComponent;
    $duration: GzTimePickerWebComponent;
    $title: GzTitleWebComponent;

    $saveButton: GzButtonWebComponent;
    $cancelButton: GzButtonWebComponent;
  };

  buildSuccessView(data: IntegrityMonitorPauseSchema) {
    this.setTargets(data.formValue);
  }

  public buildErrorView(error: Error) {
    console.error(error);
    this.dom.$saveButton.disabled = true;
  }

  public getDomElements() {
    this.dom = {
      $targetsLabel: this.shadow.querySelector('#integrity-monitor-pause-targets'),
      $targetsValue: this.shadow.querySelector('#integrity-monitor-pause-targets-value'),
      $durationLabel: this.shadow.querySelector('#integrity-monitor-pause-duration-label'),
      $duration: this.shadow.querySelector('#integrity-monitor-pause-duration'),
      $title: this.shadow.querySelector('#integrity-monitor-title'),
      $saveButton: this.shadow.querySelector('#save-button'),
      $cancelButton: this.shadow.querySelector('#cancel-button'),
    };

    this.setTranslatedStrings();
    this.setDefaultValues();
  }

  setDefaultValues() {
    this.dom.$saveButton.disabled = true;
  }

  setTranslatedStrings() {
    this.dom.$title.innerText = this.dependencies.translateFn('Suspend Integrity Monitoring task');

    this.dom.$durationLabel.label = this.dependencies.translateFn('Duration');
    this.dom.$duration.hourLabel = this.dependencies.translateFn('hours');
    this.dom.$duration.minuteLabel = this.dependencies.translateFn('minutes');

    this.dom.$saveButton.innerText = this.dependencies.translateFn('Run');
    this.dom.$cancelButton.innerText = this.dependencies.translateFn('Cancel');
  }

  setTargets(targets) {
    this.dom.$targetsLabel.label = this.dependencies.translateFn('Targets') + ` (${targets.length})`;
    this.dom.$targetsValue.innerText = targets.map(target => target.endpointName).join(', ');
  }
}
